module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-3840-45aef7fa941a1ae876ea3bb4e836990a.jpg";